import React from 'react'

import { ErrorHandler, Header, Loader } from 'components'
import { makeTraceDetails, Page } from 'common'
import { TServiceData } from 'common/types'
import { useLocation } from 'react-router-dom'

import { ServiceDetailsView } from './ServiceDetailsView'
import { useServiceDetails } from '../hooks/useServiceDetails'

export function ServiceDetails() {
  const { state } = useLocation()

  const service = state as TServiceData | undefined

  const {
    content,
    tag,
    service: serviceData,
    trackingStatus,
    sendDocuments,
    isCompleted,
    hasScroll,
    ref,
    isActive,
    isAppLoading,
    isAppError,
    isCanceled,
    isAwaitingProtocol,
    isLoadingRating,
    clipboardFeedbackMessage,
    onRateYourService,
    copyProtocol,
    onClick,
    onSendDocuments,
  } = useServiceDetails({ service })

  const { pageTitle, aboutYourRequest, supportResponse, trackYourRequest } = content

  const isError =
    isAppError ||
    !serviceData ||
    !pageTitle ||
    !aboutYourRequest ||
    !supportResponse ||
    !trackYourRequest

  if (isAppLoading) return <Loader />

  if (isError || !trackingStatus || !isActive) {
    const traceDetails = makeTraceDetails(isActive, {
      service,
      pageTitle,
      aboutYourRequest,
      supportResponse,
      trackYourRequest,
      trackingStatus,
    })

    return <ErrorHandler traceDetails={traceDetails} componentName={ServiceDetails.name} />
  }

  return (
    <Page>
      <Header title={pageTitle} />
      <ServiceDetailsView
        copyProtocol={copyProtocol}
        onClick={onClick}
        onSendDocuments={onSendDocuments}
        onRateYourService={onRateYourService}
        isLoadingRating={isLoadingRating}
        clipboardFeedbackMessage={clipboardFeedbackMessage}
        hasScroll={hasScroll}
        aboutYourRequest={aboutYourRequest}
        supportResponse={supportResponse}
        trackYourRequest={trackYourRequest}
        service={serviceData}
        tag={tag}
        trackingStatus={trackingStatus}
        sendDocuments={sendDocuments}
        isCompleted={isCompleted}
        isCanceled={isCanceled}
        customRef={ref}
        isAwaitingProtocol={isAwaitingProtocol}
      />
    </Page>
  )
}
